import { BaseService } from "./BaseService";
import {
  CreateRequestFeedbackDto,
  RequestFeedback,
  RequestFeedbackFilters,
  RequestFeedbackResponse,
  UpdateRequestFeedbackDto,
} from "@/types/requestFeedback";
import { IRequestFeedbackService } from "./interfaces/IRequestFeedbackService";

class RequestFeedbackService
  extends BaseService
  implements IRequestFeedbackService
{
  private basePath = "/requests";

  constructor() {
    super();
  }

  async getRequestFeedback(
    filters: RequestFeedbackFilters,
  ): Promise<RequestFeedbackResponse> {
    const { requestId, ...rest } = filters;
    return this.get<RequestFeedbackResponse>(
      `${this.basePath}/${requestId}/feedbacks`,
      rest,
    );
  }

  async create(data: CreateRequestFeedbackDto): Promise<RequestFeedback> {
    const { requestId, ...body } = data;
    return this.post<RequestFeedback>(
      `${this.basePath}/${requestId}/feedbacks`,
      body,
    );
  }

  async update(
    id: string,
    data: UpdateRequestFeedbackDto,
  ): Promise<RequestFeedback> {
    return this.patch<RequestFeedback>(
      `${this.basePath}/${id}/feedbacks`,
      data,
    );
  }

  async deleteFeedback(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}/feedbacks`);
  }
}

export const requestFeedbackService = new RequestFeedbackService();
